import { AppConfig } from '../app-config';

const developmentConfig: AppConfig = {
  appName: 'bend-patient',
  baseApiPath: 'http://localhost:21003',
  authenticatedRootUrl: '/home',
  unAuthenticatedRootUrl: '/login',
  apmUrl: 'https://bh-apm.bh-staging.com',
  apmEnv: 'development',
  openReplayConfig: {
    projectKey: 'Z8GmkIh3ehgLhd6SAc86',
    ingestPoint: 'https://or-testing.bh-staging.com/ingest',
    enabled: false,
  },
  auth0: {
    domain: DOTENV?.AUTH0_DOMAIN ?? '',
    clientId: DOTENV?.AUTH0_CLIENT_ID ?? '',
    audience: DOTENV?.AUTH0_AUDIENCE ?? '',
  },
  keycloak: {
    enabled:
      DOTENV?.AUTH_USE_KEYCLOAK === 'true' ??
      AUTH_USE_KEYCLOAK === 'true' ??
      true,
    authority: DOTENV?.KEYCLOAK_AUTHORITY ?? '',
    clientId: DOTENV?.KEYCLOAK_CLIENT_ID ?? '',
  },
  calendly: {
    onboardingMeetingURL:
      'https://calendly.com/bcm-intake/bend-health-bcm-evaluation-45-min-staging',
  },
  launchDarklyKey: '62700523ae799e15c1e14908',
  launchDarklyDisable: true,
  stripeKey:
    'pk_test_51JjNzpFEZYlgNqDIlT9801p31tifytbne53X6CeL1uSL13APa0Fah478jyqmqK4AKUN4Lyq3P7t8JXaxBtcr9d00007nOiO1xW',
  stripePackages: {
    // C3
    PsychLed: {
      title: 'Coaching, Therapy & Medication',
      subtitle: '',
      offerText: '',
      price: '549.99',
      timeframe: 'per month',
      stripePriceId: 'price_1LG7dqFEZYlgNqDIxlHKReLW',
    },
    // C2
    CoachingAndTherapy: {
      title: 'Coaching + Therapy',
      subtitle: '',
      offerText: '',
      price: '399.99',
      timeframe: 'per month',
      stripePriceId: 'price_1JmT9HFEZYlgNqDIcE2MbPfz',
    },
    // C1
    CoachingOnly: {
      title: 'Coaching',
      subtitle: '',
      offerText: '',
      price: '199.99',
      timeframe: 'per month',
      stripePriceId: 'price_1LG7d4FEZYlgNqDIHa0nNkLi',
    },
  },
  stripePackagesOneOneTwentyThree: {
    // C3
    PsychLed: {
      title: 'Coaching, Therapy & Medication',
      subtitle: '',
      offerText: '',
      price: '549.99',
      timeframe: 'per month',
      stripePriceId: 'price_1MKvWlFEZYlgNqDIVcUPYjxd',
    },
    // C2
    CoachingAndTherapy: {
      title: 'Coaching + Therapy',
      subtitle: '',
      offerText: '',
      price: '399.99',
      timeframe: 'per month',
      stripePriceId: 'price_1MKvWHFEZYlgNqDIKuuGQHbB',
    },
    // C1
    CoachingOnly: {
      title: 'Coaching',
      subtitle: '',
      offerText: '',
      price: '199.99',
      timeframe: 'per month',
      stripePriceId: 'price_1MKvV6FEZYlgNqDIoU0GDLTf',
    },
  },
  tokenOfTrust: {
    domain: 'sandbox.tokenoftrust.com',
    publicKey: 'public_test_6WNxREwyZNcF0LmfV1Sn',
  },
  ziggeoApiKey: '84fb4f5089ccc701377370f7c684098b',
  streamChatAppId: 'b8k6sg9jakrr',
  streamChatDisable: true,
  pasteTeaseId: 'bZz5dYZVkgIZDAYIazlHLayy83zqg3X6sKnlUH56',
  braze: {
    apiKey: '5ef29f27-20b8-47c1-ab8a-61c3e32bc485',
    baseUrl: 'https://sdk.iad-02.braze.com',
    enableLogging: true,
  },
};

export default developmentConfig;
